import { render, staticRenderFns } from "./OfficeSign.vue?vue&type=template&id=700c4106&scoped=true&"
import script from "./OfficeSign.vue?vue&type=script&lang=js&"
export * from "./OfficeSign.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSign.vue?vue&type=style&index=0&id=700c4106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c4106",
  null
  
)

export default component.exports